module.exports = __webpack_public_path__ + "79507380107ee0fffcd84fce95bae878.png";